import React, { useState } from 'react';
import { WorklogItem, WorklogLink, Label, JiraIssueStyled, StyledHeader, ToggleButton, LogsContainer, TimeRow, UnSettledTime } from './styled';
import { formatTime, parseJiraTime } from '../../utils/timeCalculations';

export const UniversalJiraList = ({ items, config }) => {
  const [expandedStates, setExpandedStates] = useState({});

  const toggleExpand = (key) => {
    setExpandedStates((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const getTotalTimeSpent = (worklogs) => {
    if (config.filterByMonth) {
      const { startDate, endDate } = getStartEndDate(config.selectedMonth, config.selectedYear);
      return worklogs.reduce((total, log) => {
        const logDate = new Date(log.started);
        return logDate >= startDate && logDate <= endDate ? total + log.timeSpentSeconds : total;
      }, 0);
    }
    return worklogs.reduce((total, log) => total + log.timeSpentSeconds, 0);
  };

  const getStartEndDate = (month, year) => {
    const startDate = new Date(Date.UTC(year, month, 1));
    const endDate = new Date(Date.UTC(year, month + 1, 0));
    return { startDate, endDate };
  };

  if (!items) {
    return <p>Brak wyników dla bieżących ustawień!</p>;
  }

  return (
    <JiraIssueStyled>
      {items.map((item) => {
        const worklogs = config.getWorklogs(item);
        const totalTimeSpent = getTotalTimeSpent(worklogs);

        return (
          <WorklogItem key={config.getKey(item)}>
            <StyledHeader>
              <h3>{config.getTitle(item)}</h3>
              {config.getLabels(item)?.includes('NIESERWISOWE') && <Label>NIESERWISOWE</Label>}
            </StyledHeader>
            <WorklogLink href={config.getLink(item)} target="_blank">{config.getLink(item)}</WorklogLink>
            <p>Status: <strong>{config.getStatus(item)}</strong></p>
            <p>{config.getReporterLabel()} <strong>{config.getReporter(item)}</strong></p>
            <div>
              <p>Czas szacowany: <strong>{formatTime(parseJiraTime(config.getOriginalEstimate(item)))}</strong></p>
              <TimeRow>
                <p>{config.getLoggedTimeLabel()} <strong>{formatTime(totalTimeSpent)}</strong></p>
                {worklogs.length > 0 && (
                  <ToggleButton onClick={() => toggleExpand(config.getKey(item))}>
                    {expandedStates[config.getKey(item)] ? 'Zwiń szczegóły rejestracji' : 'Pokaż szczegóły rejestracji'}
                  </ToggleButton>
                )}
              </TimeRow>
              <LogsContainer $expanded={expandedStates[config.getKey(item)]}>
                {worklogs.map((log, index) => (
                  <p key={log.id}>
                    {index + 1}. Czas rejestracji: <strong>{formatTime(log.timeSpentSeconds)}</strong> - Data: {new Date(log.started).toLocaleDateString('pl-PL')}
                  </p>
                ))}
              </LogsContainer>
              {parseJiraTime(config.getOriginalEstimate(item)) > totalTimeSpent && (
                <UnSettledTime>
                  Czas pozostały do zarejestrowania: <strong>{formatTime(parseJiraTime(config.getOriginalEstimate(item)) - totalTimeSpent)}</strong>
                </UnSettledTime>
              )}
            </div>
          </WorklogItem>
        );
      })}
    </JiraIssueStyled>
  );
};
